module.exports = __webpack_public_path__ + "img/necklace.0e34e70a.png";